import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteAllVersionContentOnSiteParams {
  siteId: string;
}

export interface IDeleteAllVersionContentOnSiteResult extends IResult {
}

export class DeleteAllVersionContentOnSiteRequest
  extends Request<IDeleteAllVersionContentOnSiteParams, IDeleteAllVersionContentOnSiteResult> {

  constructor(params: IDeleteAllVersionContentOnSiteParams) {
    super('deleteAllVersionContentOnSite', params);
  }
}
